import {
  AutoAwesomeOutlined,
  BackupTableOutlined,
  ChatOutlined,
  ImageOutlined,
  PermMediaOutlined,
  PsychologyAltOutlined,
  VideoLibraryOutlined,
  ViewInArOutlined,
  Slideshow,
} from '@mui/icons-material'
import { ARCANA_ENABLED, PROJECTS_ENABLED } from './featureFlags'

export const NAV_ITEMS = [
  {
    name: 'Cronologia Chat',
    key: 'home',
    icon: ChatOutlined,
    route: '/',
    isDropdown: true,
  },
  ...(ARCANA_ENABLED
    ? [
        {
          name: 'Arcano',
          key: 'arcano',
          icon: AutoAwesomeOutlined,
          route: '/',
          isDropdown: true,
        },
      ]
    : []),
  ...(PROJECTS_ENABLED
    ? [
        {
          name: 'Progetti',
          key: 'projects',
          icon: BackupTableOutlined,
          route: '/',
          isDropdown: true,
        },
      ]
    : []),
  {
    name: 'Memorie',
    key: 'memories',
    icon: PsychologyAltOutlined,
    route: '/memories',
    isDropdown: false,
  },
  {
    name: 'Assets Chat',
    key: 'chat_assets',
    icon: PermMediaOutlined,
    route: '/chat/assets',
    isDropdown: false,
  },
  {
    name: 'Generazione Immagini',
    key: 'image_generation',
    icon: ImageOutlined,
    route: '/generate/image',
    isDropdown: false,
  },
  {
    name: 'Generazione Video',
    key: 'video_generation',
    icon: VideoLibraryOutlined,
    route: '/generate/video',
    isDropdown: false,
  },
  {
    name: 'Generazione Presentazioni',
    key: 'presentation_generation',
    icon: Slideshow,
    route: '/generate/presentation',
    isDropdown: false,
  },
  {
    name: 'Designer CAD',
    key: 'cad_generation',
    icon: ViewInArOutlined,
    route: '/generate/cad',
    isDropdown: false,
  },
]
